export type RedirectValues =
  | 'product'
  | 'url'
  | 'app_screen'
  | 'app_screen_custom'
  | 'dynamic_tabs'
  | 'webview'
  | 'query';

const redirectTypes: { label: string; value: RedirectValues }[] = [
  {
    label: 'Produto',
    value: 'product',
  },
  {
    label: 'URL',
    value: 'url',
  },
  {
    label: 'Tela dinâmica',
    value: 'app_screen',
  },
  {
    label: 'Webview',
    value: 'webview',
  },
  {
    label: 'Query Vtex',
    value: 'query',
  },
  {
    label: 'Telas do app',
    value: 'app_screen_custom',
  },
  {
    label: 'Abas dinâmicas',
    value: 'dynamic_tabs',
  },
];

export default redirectTypes;
